<template>
  <div>
    <b-modal size="xl" no-close-on-backdrop no-close-on-esc hide-footer id="editOrganicSocialMediaPlanModal"
        title="Edit Organic Social Media Plan" class="modal-edit-deliverable" @hide="editOrganicSocialModalPlanHidden"
        @shown="pushRoute" @hidden="editOrganicSocialModalPlanHiddenComplete">
        <EditOrganicSocialMediaPlanModal ref="refEditOrganicSocialMediaPlanModal" :tabIndex="tabIndex"
          :namespace="namespace" />
    </b-modal>
    <RelatedDeliverablesSchedule v-if="systemSettingsReady" :parentDeliverableId="parentDeliverableId" :namespace="namespace"
      :tabTitle="'scheduled-content'"  :key="'sms-rds'" ref="refRelatedDeliverablesSchedule" :showLogo="true" :openedDirectlyWithModal="openedDirectlyWithModal" @resetOpenedDirectly="openedDirectlyWithModal = false"/>
  </div>
</template>
<script>
import RelatedDeliverablesSchedule from "../components/deliverables/RelatedDeliverablesSocialMediaSchedule";
import EditOrganicSocialMediaPlanModal from "../components/deliverables/EditOrganicSocialMediaPlanModal";

import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
    	parentDeliverableId:null,
    	namespace:"",
      expandAll: !this.isMobile(),
      systemSettingsReady: false,
      namespace:"",
      openedDirectlyWithModal: false,
	tabIndex: 1,
      initialDataLoaded: false,
      pendingDeliverableId: null,
      hasModalHistoryEntry: false,
    }
  },
  computed: {
  		...mapState({
  	  state (state) {
  	    return state[this.namespace]
  	  },
  	  allCustomFields (state, getters) {
  	    return getters[this.namespace + 'allCustomFields']
  	  },
  	  allUsers (state, getters) {
  	    return getters['allUsers']
  	  },
  	  systemSettings (state, getters) {
  	    return getters['systemSettings']
  	  },
        deliverableDetail(state, getters) {
          return getters[this.namespace + 'deliverableDetail']
        },
        getDeliverableTemplateSlug(state, getters) {
          return getters[this.namespace + "getDeliverableTemplateSlug"];
        },
  	}),
    forceUpdateCounter() {
      return this.$store.state.deliverables.forceUpdateCounter
    },
    statuses() {
      let statusField = _.find(this.allCustomFields, { field_key: "status" });
      if (typeof statusField != "undefined") {
        let valueSet = [],
          data = JSON.parse(statusField.value_set);
        Object.keys(data).forEach(function(item) {
          valueSet.push(data[item]);
        });
        return valueSet;
      }
    }
  },
  components: {
    EditOrganicSocialMediaPlanModal,
  	RelatedDeliverablesSchedule,
  },
  methods: {
  	...mapActions({
  	  fetchSystemSettings (dispatch, payload) {
  	    return dispatch(this.namespace + 'fetchSystemSettings', payload)
  	  },
  	  getDeliverableTypes (dispatch, payload) {
  	    return dispatch(this.namespace + 'getDeliverableTypes', payload)
  	  },
  	}),
 	openDeliverableModalFromRoute(deliverableId, navigateCalendar = false) {
      const urlParams = new URLSearchParams(window.location.search);
      const tabParam = urlParams.get('tab');
      if (tabParam !== null) {
        this.tabIndex = parseInt(tabParam) || 1;
      } else {
        this.tabIndex = 1;
      }
      
  	  this.$store.dispatch(this.namespace + "getDeliverableDetail", { deliverableId })
      .then(() => {
        const slug = this.deliverableDetail.deliverable_template?.slug || 
                     this.getDeliverableTemplateSlug(parseInt(this.deliverableDetail.deliverable_template_id));
        if (slug === 'organic-social-media-plan') {
           this.$bvModal.show("editOrganicSocialMediaPlanModal");
        } else {
           if (navigateCalendar) {
             this.navigateCalendarToDeliverableDate();
           }
           this.$nextTick(() => {
             if (this.$refs.refRelatedDeliverablesSchedule) {
                 this.$refs.refRelatedDeliverablesSchedule.openModalFromParent();
             }
           });
        }
      });
  	},
  	getTargetPublishDate() {
  	  if (!this.deliverableDetail) return null;
  	  let allDates = [];
  	  if (this.deliverableDetail.social_series_deliverables && 
  	      this.deliverableDetail.social_series_deliverables.length > 0) {
  	    allDates = this.deliverableDetail.social_series_deliverables
  	      .filter(d => d.publish_date)
  	      .map(d => ({
  	        publish_date: d.publish_date,
  	        published_at: d.published_at
  	      }));
  	  } else if (this.deliverableDetail.publish_date) {
  	    allDates = [{
  	      publish_date: this.deliverableDetail.publish_date,
  	      published_at: this.deliverableDetail.published_at
  	    }];
  	  }
  	  if (allDates.length === 0) return null;
  	  const unpublishedDates = allDates.filter(d => !d.published_at);
  	  if (unpublishedDates.length > 0) {
  	    return unpublishedDates.reduce((earliest, current) => {
  	      const currentDate = new Date(current.publish_date);
  	      const earliestDate = new Date(earliest.publish_date);
  	      return currentDate < earliestDate ? current : earliest;
  	    }).publish_date;
  	  } else {
  	    return allDates.reduce((latest, current) => {
  	      const currentDate = new Date(current.publish_date);
  	      const latestDate = new Date(latest.publish_date);
  	      return currentDate > latestDate ? current : latest;
  	    }).publish_date;
  	  }
  	},
	getTargetDateAndViewMode() {
	  if (!this.deliverableDetail) return { targetDate: null, viewMode: 'month' };
	  const toDayMoment = (d) => this.$moment.utc(d).local().startOf('day');
	  const toFullMoment = (d) => this.$moment.utc(d).local();
	  const today = this.$moment().startOf('day');
	  let allDates = [];
	  if (this.deliverableDetail.social_series_deliverables && 
	      this.deliverableDetail.social_series_deliverables.length > 0) {
	    allDates = this.deliverableDetail.social_series_deliverables
	      .filter(d => d.publish_date)
	      .map(d => ({
	        publish_date: d.publish_date,
	        published_at: d.published_at
	      }));
	  } else if (this.deliverableDetail.publish_date) {
	    allDates = [{
	      publish_date: this.deliverableDetail.publish_date,
	      published_at: this.deliverableDetail.published_at
	    }];
	  }
	  if (allDates.length === 0) return { targetDate: null, viewMode: 'month' };
	  const unpublishedDates = allDates.filter(d => !d.published_at);
	  const sortable = unpublishedDates.length > 0 ? unpublishedDates : allDates;
	  const closestToToday = sortable.reduce((closest, current) => {
	    const currentDiff = Math.abs(toDayMoment(current.publish_date).diff(today, 'days'));
	    const closestDiff = Math.abs(toDayMoment(closest.publish_date).diff(today, 'days'));
	    return currentDiff < closestDiff ? current : closest;
	  });
	  const targetMoment = toFullMoment(closestToToday.publish_date);
	  let viewMode = 'month';
	  if (sortable.length === 1) {
	    viewMode = 'day';
	  } else {
	    const targetDay = toDayMoment(closestToToday.publish_date);
	    const sameWeek = sortable.every(d => toDayMoment(d.publish_date).isSame(targetDay, 'week'));
	    if (sameWeek) {
	      viewMode = 'week';
	    } else {
	      viewMode = 'month';
	    }
	  }
	  return { targetDate: targetMoment.toDate(), viewMode };
	},
  	navigateCalendarToDeliverableDate() {
  	  const { targetDate, viewMode } = this.getTargetDateAndViewMode();
  	  if (!targetDate) return;
  	  
  	  this.$nextTick(() => {
  	    if (this.$refs.refRelatedDeliverablesSchedule && 
  	        this.$refs.refRelatedDeliverablesSchedule.$refs.refSocialScheduleCalendar) {
  	      this.$refs.refRelatedDeliverablesSchedule.$refs.refSocialScheduleCalendar
  	        .navigateToDate(new Date(targetDate), viewMode);
  	    }
  	  });
  	},
    openChildDeliverableFromUrl(deliverableId) {
      if (!deliverableId) return;
      const path = window.location.pathname;
      const match = path.match(/\/social-media-schedule\/(\d+)/);
      const parentDeliverableId = match ? match[1] : null;
      const osmpModalEl = document.getElementById('editOrganicSocialMediaPlanModal');
      const isOsmpOpen = osmpModalEl?.classList.contains('show');
      const childModalEl = document.getElementById('editRelatedSocialModal');
      const isChildModalOpen = childModalEl?.classList.contains('show');
      if (isChildModalOpen) {
        return;
      }
      
      const openChildModalInOsmp = () => {
        this.$nextTick(() => {
          const osmpRef = this.$refs.refEditOrganicSocialMediaPlanModal;
          if (osmpRef && osmpRef.$refs.refRelatedDeliverablesSchedule) {
            osmpRef.$refs.refRelatedDeliverablesSchedule.showEditDeliverableModal(parseInt(deliverableId), 2);
          }
        });
      };
      
      if (!isOsmpOpen) {
        if (parentDeliverableId) {
          this.$store.dispatch(this.namespace + "getDeliverableDetail", { deliverableId: parentDeliverableId })
            .then(() => {
              this.hasModalHistoryEntry = true;
              this.$bvModal.show("editOrganicSocialMediaPlanModal");
              setTimeout(() => {
                openChildModalInOsmp();
              }, 400);
            });
        }
      } else {
        openChildModalInOsmp();
      }
    },
    editOrganicSocialModalPlanHidden() {
			this.$store.commit(this.namespace + 'setDeliverable', this.deliverableDetail);
			if (window.__osmpClosedByPopstate) {
				window.__osmpClosedByPopstate = false;
				return;
			}
			const path = window.location.pathname;
			const match = path.match(/\/social-media-schedule\/(\d+)/);
			const urlDeliverableId = match ? match[1] : null;
			if (urlDeliverableId) {
				if (this.openedDirectlyWithModal) {
					this.openedDirectlyWithModal = false;
					this.navigateToSchedulePage();
				} else {
					this.navigateToSchedulePage();
				}
			}
		},
		editOrganicSocialModalPlanHiddenComplete() {
			this.hasModalHistoryEntry = false;
		},
    navigateToSchedulePage() {
      this.$router.replace({ name: 'socialMediaSchedule' });
    },
    pushRoute() {
			const url = this.buildModalUrl();
			const currentPath = window.location.pathname;
			const currentSearch = window.location.search;
			const currentUrl = currentPath + currentSearch;
			const targetPathMatch = url.match(/^([^?]+)/);
			const targetPath = targetPathMatch ? targetPathMatch[1] : url;
			const isAlreadyOnModalUrl = currentPath.includes('/social-media-schedule/' + this.deliverableDetail.id);
			
			if (this.hasModalHistoryEntry || isAlreadyOnModalUrl) {
				history.replaceState({}, null, url);
				this.hasModalHistoryEntry = true;
			} else {
				history.pushState({}, null, url);
				this.hasModalHistoryEntry = true;
			}
			
			let currentTitle = document.title.match(/\(\d+\)\s/g);
			if(!currentTitle) {
				document.title = this.deliverableDetail.title;
			} else {
				document.title = currentTitle[0] + this.deliverableDetail.title;
			}
		},
		buildModalUrl() {
			let url = '/social-media-schedule/' + encodeURIComponent(this.deliverableDetail.id);
			if (this.deliverableDetail.slug) {
				url += '/' + encodeURIComponent(this.deliverableDetail.slug) + '/';
			}
			url += '?tab=' + this.tabIndex;
			return url;
		},
		updateUrlWithTab(tabIndex) {
			if (!this.deliverableDetail?.id) return;
			this.tabIndex = tabIndex;
			const url = this.buildModalUrl();
			history.replaceState({}, null, url);
		},
		removeRoute() {
			history.pushState(
				{},
				null,
				this.$router.currentRoute.matched[0].path
			);
		},
    collapseToggleUpdate(expandAll) {
      this.expandAll = expandAll
    },
    checkSystemSettingsReady(){
      if(this.systemSettings.publish_statuses){
        this.systemSettingsReady = true;


      	this.$nextTick(() => {
          // force resize of schedule
          if (this.$refs.refRelatedDeliverablesSchedule) {
        	  this.$refs.refRelatedDeliverablesSchedule.$refs.refSocialScheduleCalendar.forceResizeCalender();
        	  // this.$refs.refRelatedDeliverablesSchedule.$refs.refHeaderControls.applyFilter();
        	}
        });

      } else {
        this.systemSettingsReady = false;
      }
    },
  },
  mounted(){
    document.body.classList.add("social-media");
    this.getDeliverableTypes().then(() => {
      this.initialDataLoaded = true;
      if (this.pendingDeliverableId) {
        this.openDeliverableModalFromRoute(this.pendingDeliverableId, true);
        this.pendingDeliverableId = null;
      }
    }).catch(() => {
      this.initialDataLoaded = true;
    });

    if (this.$route.params.deliverableId) {
      if (this.initialDataLoaded) {
        this.openDeliverableModalFromRoute(this.$route.params.deliverableId, true);
      } else {
        this.pendingDeliverableId = this.$route.params.deliverableId;
      }
    }

    this.handleOsmpPopstate = (event) => {
      const path = window.location.pathname;
      const hasDeliverableId = /\/social-media-schedule\/\d+/.test(path);
      const query = new URLSearchParams(window.location.search);
      const openDeliverable = query.get('openDeliverable');
      
      if (!hasDeliverableId) {
        window.__osmpClosedByPopstate = true;
        this.$bvModal.hide("editOrganicSocialMediaPlanModal");
        this.$bvModal.hide("editSocialModal");
        this.$bvModal.hide("editRelatedSocialModal");
      } else if (hasDeliverableId && openDeliverable) {
        this.openChildDeliverableFromUrl(openDeliverable);
      } else if (hasDeliverableId && !openDeliverable) {
        this.$bvModal.hide("editSocialModal");
        this.$bvModal.hide("editRelatedSocialModal");
      }
    };
    window.addEventListener('popstate', this.handleOsmpPopstate);
  },
  created(){
    const path = window.location.pathname;
    const isModalUrl = /\/social-media-schedule\/\d+/.test(path);
    const navEntries = performance.getEntriesByType('navigation');
    const navigationType = navEntries.length > 0 ? navEntries[0].type : 'navigate';
    const isReload = navigationType === 'reload';
    if (isModalUrl && !document.referrer && !isReload) {
      this.openedDirectlyWithModal = true;
    }
    this.fetchSystemSettings();
    this.checkSystemSettingsReady();
  },
  watch:{
		systemSettings (to, from){
			console.log("systemSettings changed");
      this.checkSystemSettingsReady();
		},
    '$route.params.deliverableId': {
      handler(newId, oldId) {
        if (newId && newId !== oldId) {
          if (this.initialDataLoaded) {
            this.openDeliverableModalFromRoute(newId);
          } else {
            this.pendingDeliverableId = newId;
          }
        }
		}
	}
  },
  beforeDestroy() {
    if (this.$bvModal && this.$bvModal.hide) {
      this.$bvModal.hide("editOrganicSocialMediaPlanModal");
      this.$bvModal.hide("editSocialModal");
      this.$bvModal.hide("editRelatedSocialModal");
    }
    document.body.classList.remove("social-modal-open", "social-modal-shown", "social-media");
    if (this.handleOsmpPopstate) {
      window.removeEventListener('popstate', this.handleOsmpPopstate);
    }
  },
}
</script>
